import React from 'react';
import TanFilterVideo from '../../components/TanFilterVideo/TanFilterVideo';

// Standalone "Spray Tan Try On". The shell flags /fullscreenFilter as full-bleed
// (see FULL_BLEED in layout.js), so the camera surface fills the content area.
const FullscreenFilter = () => {
  return <TanFilterVideo />;
};

export default FullscreenFilter;
